module.exports = __webpack_public_path__ + "static/media/Postales-01.bd03ed2c.png";